module.exports = __webpack_public_path__ + "img/icon-sv2.947fcc7b.png";